import { useEffect } from 'react';

const DEFAULT_TITLE = 'IVA - Intelligent Virtual Assistant';

/**
 * Sets document.title while the calling screen is mounted and restores the
 * default on unmount, so screen-reader users get a meaningful page name per
 * route (WCAG 2.4.2).
 */
export const usePageTitle = (title?: string | null): void => {
  useEffect(() => {
    if (!title) return undefined;
    document.title = `${title} - IVA`;
    return () => { document.title = DEFAULT_TITLE; };
  }, [title]);
};

export default usePageTitle;
